import { GzSelectWebComponent } from './component/GzSelectWebComponent';
import { SelectOverlayElement } from './component/SelectOverlay';

export { GzSelectWebComponent, SelectOverlayElement };

window.customElements.define(SelectOverlayElement.is, SelectOverlayElement);
